import Vue from 'vue'
import VueRouter from 'vue-router'
import { authGuard, titleGuard, errorGuard } from './guards'

// 기능별 라우트 모듈
import mpcRoutes from './routes/mpc'
import skyplayRoutes from './routes/skyplay'
import settingsRoutes from './routes/settings'
import erc20Routes from './routes/erc20'
import erc721Routes from './routes/erc721'
import erc1155Routes from './routes/erc1155'
import arenaRoutes from './routes/arena'
import metaplanetRoutes from './routes/metaplanet'
import metaplanetTokenRoutes from './routes/metaplanetToken'
import metaplanetLogRoutes from './routes/metaplanetLog'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/metaplanet_lbank',
  },
  ...mpcRoutes,
  ...skyplayRoutes,
  ...settingsRoutes,
  ...erc20Routes,
  ...erc721Routes,
  ...erc1155Routes,
  ...arenaRoutes,
  ...metaplanetRoutes,
  ...metaplanetTokenRoutes,
  ...metaplanetLogRoutes,
  // Test 라우트
  {
    path: '/testview',
    name: 'TestView',
    component: () =>
      import(/* webpackChunkName: "test" */ '@/views/Test/TestView.vue'),
    meta: { title: 'Test', group: 'test' },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// 라우트 가드 적용
router.beforeEach(authGuard)
router.beforeEach(titleGuard)
router.beforeEach(errorGuard)

export default router
